module.exports = __webpack_public_path__ + "img/engage-fig-2.b9017a33.png";